"use strict";
/**
 * @module Client.Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service implementation to provide Ping functionality.
 *
 * Intended to provide basic Ping functionality by immediately responding to a
 * received request, by which the round-trip latency between the sender and
 * receiver may be ascertained.
 */
exports.pingService = {
    /**
     * Handle an inbound request
     *
     * @param internal  the internal session instance
     * @param ping      the inbound ping request
     * @param callback  the service reference callback
     */
    onRequest: function (internal, ping, callback) {
        callback.respond();
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/services/ping-service.js
// module id = 1192
// module chunks = 1